import Vue from 'vue';
import request from '../../request';

export default {
  namespaced: true,
  state: {
    form: {
      justification: '',
    },
    formErrors: {
      justification: [],
    },
    data: [],
    waiting: [],
  },
  mutations: {
    setBookings(state, data) {
      Vue.set(state, 'data', data);
    },
    setConfirmedByCode(state, code) {
      Object.keys(state.data).forEach((key) => {
        if (state.data[key] === code) {
          Object.assign(state.data[key], { state: 'Confirmed' });
          Object.assign(state.data[key], { state_id: 2 });
        }
      });
    },
    setRejectedByCode(state, code) {
      Object.keys(state.data).forEach((key) => {
        if (state.data[key].reservation_code === code) {
          Object.assign(state.data[key], { state: 'Rejected' });
          Object.assign(state.data[key], { state_id: 4 });
        }
      });
    },
    setFormValue(state, { field, value }) {
      Object.assign(state.form, { [field]: value });
    },
    setFormErrors(state, formErrors) {
      Vue.set(state, 'formErrors', formErrors);
    },
    setWaitingFromOccurrences(state, occurrences) {
      const waiting = [];
      occurrences.forEach((occurrence) => {
        occurrence.bookings.data.forEach((booking) => {
          if (booking.state_id === 1 && booking.has_been_paid) {
            waiting.push(booking);
          }
        });
      });
      Object.assign(state, { waiting });
    },
  },
  actions: {
    setFormValue(context, payload) {
      context.commit('setFormValue', payload);
    },
    get(context) {
      return new Promise((resolve) => {
        const promoter = context.rootState.promoter.data.id;
        const url = `${process.env.API_URL}activity_booking`;
        request.make({
          type: 'GET',
          url,
          data: { promoter },
        }, (err, res) => {
          if (res.status === 200) {
            context.commit('setBookings', res.body.data);
            resolve();
          }
        });
      });
    },
    setWaitingFromOccurrences(context, occurrences) {
      context.commit('setWaitingFromOccurrences', occurrences);
    },
    confirm(context, code) {
      return new Promise((resolve) => {
        const url = `${process.env.API_URL}activity_booking`;
        request.make({
          type: 'PUT',
          url,
          data: { code, accept: true },
        }, (err, res) => {
          if (res.status === 204) {
            context.commit('setConfirmedByCode', code);
            // context.dispatch('occurrencePromoter/get', null, { root: true });
            resolve();
          }
        });
      });
    },
    reject(context, code) {
      return new Promise((resolve) => {
        const url = `${process.env.API_URL}activity_booking`;
        context.commit('setShowAllValidationErrors', true, { root: true });
        request.make({
          type: 'PUT',
          url,
          data: { code, accept: false, justification: context.state.form.justification },
        }, (err, res) => {
          if (res.status === 204) {
            context.commit('setRejectedByCode', code);
            // TODO: Remove from list
            context.commit('occurrencePromoter/removeBooking', code, { root: true });
            context.dispatch('occurrencePromoter/get', null, { root: true });
            resolve();
          } else if (res.status === 422) {
            context.commit('setFormErrors', res.body.errors);
          }
        });
      });
    },
    cancel(context, code) {
      return new Promise((resolve) => {
        const url = `${process.env.API_URL}activity_booking`;
        context.commit('setShowAllValidationErrors', true, { root: true });
        request.make({
          type: 'PUT',
          url,
          data: { code, cancel: true, justification: context.state.form.justification },
        }, (err, res) => {
          if (res.status === 204) {
            context.commit('setRejectedByCode', code);
            // TODO: Remove from list
            context.commit('occurrencePromoter/removeBooking', code, { root: true });
            context.dispatch('occurrencePromoter/get', null, { root: true });
            resolve();
          } else if (res.status === 422) {
            context.commit('setFormErrors', res.body.errors);
          }
        });
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/promoter/booking.js